// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Post-login onboarding  (/welcome/profile → terms → delivery → consent → aboard)
// Policy-acceptance API: has this customer accepted the current Terms/Privacy/Disclaimer, and
// record that they have (GET/POST /api/me/consents). The backend writes an append-only log row per
// document plus the latest version on the customer record.
// ─────────────────────────────────────────────────────────────────────────────
import { apiAuthed } from "./api";

/**
 * The version of the legal documents shown on the charter screen. Must equal the backend's
 * POLICY_VERSION (backend/app/domain/consent.py) — a mismatch is refused with
 * POLICY_VERSION_MISMATCH, so a stale page can never record acceptance of the wrong text.
 */
export const POLICY_VERSION = "2026-08-21";

export interface ConsentState {
  currentVersion: string;
  acceptedVersion: string | null;
  acceptedAt: string | null;
  /** True when the customer has already accepted the current version. */
  upToDate: boolean;
}

export const fetchConsentState = () => apiAuthed<ConsentState>("GET", "/me/consents");

/** `version` is the server's current acceptance version (GET /me/consents → currentVersion): staff can move it forward by publishing a policy that needs fresh acceptance. */
export const acceptPolicies = (version: string = POLICY_VERSION) =>
  apiAuthed<ConsentState>("POST", "/me/consents", {
    policyVersion: version,
    documents: ["terms", "privacy", "disclaimer"],
  });
